var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "h5",
        {
          staticClass:
            "card-header d-flex justify-content-between align-items-center",
        },
        [
          _c("div", { staticClass: "flex-grow-1" }, [
            _vm._v("Сегменты клиентов (для обзвона и рассылок)"),
          ]),
          _vm._v(" "),
          _c(
            "vue-ladda",
            {
              attrs: {
                "button-class": "btn btn-sm btn-info",
                "data-style": "zoom-in",
                loading: _vm.loadingAdd,
              },
              on: {
                click: function ($event) {
                  return _vm.addItem()
                },
              },
            },
            [
              _c("i", { staticClass: "icon-fa icon-fa-plus" }),
              _vm._v("Добавить сегмент"),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticStyle: { "text-align": "center" },
            attrs: { loading: _vm.loading, color: "#007dcc" },
          }),
          _vm._v(" "),
          _c(
            "sweet-modal",
            {
              ref: "showSmsModal",
              attrs: { width: "90%", "overlay-theme": "dark" },
            },
            [
              _c("div", { staticClass: "text-left" }, [
                _vm.currentItem
                  ? _c("h5", [
                      _vm._v(
                        _vm._s(_vm.currentItem.title) +
                          " [ID: " +
                          _vm._s(_vm.currentItem.id) +
                          "]"
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "sms-table" },
                  _vm._l(_vm.smsItems, function (smsItem) {
                    return _c(
                      "div",
                      {
                        class: {
                          "sms-item": true,
                          "sms-error": smsItem.status === "0",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "sms-val",
                            staticStyle: { "min-width": "180px" },
                          },
                          [
                            _c("i", { staticClass: "icon-fa icon-fa-phone" }),
                            _vm._v(" " + _vm._s(smsItem.phone_number)),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "sms-val",
                            staticStyle: {
                              "min-width": "200px",
                              "font-size": "14px",
                            },
                          },
                          [
                            _c("i", { staticClass: "icon-fa icon-fa-user" }),
                            _vm._v(" " + _vm._s(smsItem.order.fio)),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "sms-val sms-body" }, [
                          _vm._v(_vm._s(smsItem.sms_body)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "sms-val" }, [
                          smsItem.status !== "0"
                            ? _c("span", [_vm._v("Успешно")])
                            : _c("div", [
                                _c("span", [_vm._v("Ошибка оптравки")]),
                                _c("br"),
                                _vm._v(" "),
                                smsItem.system_info
                                  ? _c("div", { staticClass: "send-error" }, [
                                      _vm._v(_vm._s(smsItem.system_info)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-sm btn-success",
                                    attrs: {
                                      disabled: _vm.loadingSend,
                                      type: "button",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.sendSms(
                                          _vm.currentItem,
                                          true,
                                          { resend: smsItem }
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-send",
                                    }),
                                    _vm._v(
                                      " Отправить повторно\n                  "
                                    ),
                                  ]
                                ),
                              ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "sweet-modal",
            {
              ref: "showClientsModal",
              attrs: { width: "90%", "overlay-theme": "dark" },
            },
            [
              _c("div", { staticClass: "text-left" }, [
                _vm.currentItem
                  ? _c("h5", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.currentItem.title) +
                          " [ID: " +
                          _vm._s(_vm.currentItem.id) +
                          "]\n            "
                      ),
                      _vm.currentItem.includeFrom || _vm.currentItem.includeTo
                        ? _c("span", { staticClass: "include-label" }, [
                            _vm._v("\n                 "),
                            _c("i", { staticClass: "icon-fa icon-fa-plus" }),
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.currentItem.includeFrom || "...") +
                                " — " +
                                _vm._s(_vm.currentItem.includeTo || "...") +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentItem.excludeFrom || _vm.currentItem.excludeTo
                        ? _c("span", { staticClass: "exclude-label" }, [
                            _vm._v("\n                 "),
                            _c("i", { staticClass: "icon-fa icon-fa-minus" }),
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.currentItem.excludeFrom || "...") +
                                " — " +
                                _vm._s(_vm.currentItem.excludeTo || "...") +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "sms-table" },
                  [
                    _c(
                      "div",
                      { staticClass: "sms-item client-item header-row" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "sms-val",
                            staticStyle: { width: "160px" },
                          },
                          [_vm._v("Дата заказа")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "sms-val" }, [
                          _vm._v("Клиент"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "sms-val" }, [
                          _vm._v("Телефон"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "sms-val" }, [
                          _vm._v("\n                Статус\n                "),
                          _c(
                            "select",
                            {
                              staticStyle: {
                                width: "130px",
                                "font-size": "13px",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.filterStatus($event)
                                },
                              },
                            },
                            [
                              _c("option", { domProps: { value: null } }, [
                                _vm._v("---"),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.segmentClientStatuses,
                                function (
                                  segmentClientStatus,
                                  segmentClientStatusId
                                ) {
                                  return _c(
                                    "option",
                                    {
                                      domProps: {
                                        value: segmentClientStatusId,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(segmentClientStatus) +
                                          "\n                  "
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "sms-val" }, [
                          _vm._v("СМС Звонок"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.clients, function (client) {
                      return _vm.currentFilterStatus === null ||
                        parseInt(_vm.currentFilterStatus) ===
                          parseInt(client.segmentClientStatus)
                        ? _c("div", { staticClass: "sms-item client-item" }, [
                            _c("div", { staticClass: "sms-val" }, [
                              _vm._v(_vm._s(client.date)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "sms-val" }, [
                              _c("i", { staticClass: "icon-fa icon-fa-user" }),
                              _vm._v(
                                " " +
                                  _vm._s(client.clientName) +
                                  "\n                "
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "14px",
                                    color: "grey",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " + _vm._s(client.city)
                                  ),
                                  client.projectLabel
                                    ? _c("span", { staticClass: "ml-1" }, [
                                        _vm._v(
                                          "(" +
                                            _vm._s(client.projectLabel) +
                                            ")"
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "sms-val" }, [
                              _c("i", { staticClass: "icon-fa icon-fa-phone" }),
                              _vm._v(" " + _vm._s(client.phone)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "sms-val" }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-bottom": "10px",
                                    "font-size": "14px",
                                    color: "#636363",
                                    "font-weight": "bold",
                                  },
                                },
                                [
                                  _vm.currentSmsClient !== client.id
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            client.segmentClientStatusLabel
                                          )
                                        ),
                                      ])
                                    : _c(
                                        "select",
                                        {
                                          attrs: {
                                            id:
                                              "segmentClientStatus" + client.id,
                                          },
                                        },
                                        _vm._l(
                                          _vm.segmentClientStatuses,
                                          function (
                                            segmentClientStatus,
                                            segmentClientStatusId
                                          ) {
                                            return _c(
                                              "option",
                                              {
                                                domProps: {
                                                  selected:
                                                    parseInt(
                                                      segmentClientStatusId
                                                    ) ===
                                                    parseInt(
                                                      client.segmentClientStatus
                                                    ),
                                                  value: segmentClientStatusId,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      segmentClientStatus
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                ]
                              ),
                              _vm._v(" "),
                              client.segmentClientComment ||
                              _vm.currentSmsClient === client.id
                                ? _c("textarea", {
                                    staticClass: "form-control mb-1",
                                    attrs: {
                                      id: "segmentClientComment" + client.id,
                                      disabled:
                                        _vm.currentSmsClient !== client.id,
                                      placeholder: "Добавить примечание",
                                    },
                                    domProps: {
                                      value: client.segmentClientComment
                                        ? client.segmentClientComment
                                        : null,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentSmsClient !== client.id
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-sm btn-default",
                                      staticStyle: { "font-size": "13px" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editSmsClient(client)
                                        },
                                      },
                                    },
                                    [_vm._v("Изменить")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentSmsClient === client.id
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-sm btn-success",
                                      staticStyle: { "font-size": "13px" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editSmsClient(client)
                                        },
                                      },
                                    },
                                    [_vm._v("OK")]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "sms-val" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-sm",
                                    class: {
                                      "btn-outline-default":
                                        client.status === null,
                                      "btn-success":
                                        client.status && client.status !== "0",
                                      "btn-danger": client.status === "0",
                                    },
                                    attrs: {
                                      disabled:
                                        _vm.loadingSend ||
                                        (client.status &&
                                          client.status !== "0"),
                                      title: "Отправить смс",
                                      type: "button",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.sendSms(
                                          _vm.currentItem,
                                          true,
                                          {
                                            resend: client.smsId
                                              ? client
                                              : null,
                                            orderDetail: !client.smsId
                                              ? client
                                              : null,
                                            handleId: client.smsId
                                              ? client.smsId
                                              : client.id,
                                          }
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-send",
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                client.phone && client.phone.length
                                  ? _c(
                                      "MakeCall",
                                      {
                                        staticClass: "d-inline-block",
                                        attrs: {
                                          phone: client.phone,
                                          order: client.order,
                                        },
                                      },
                                      [
                                        _vm._t("btn", function () {
                                          return [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-sm btn-outline-default ml-1",
                                                attrs: {
                                                  disabled: _vm.loadingSend,
                                                  title: "Звонок",
                                                  type: "button",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "icon-fa icon-fa-phone",
                                                }),
                                              ]
                                            ),
                                          ]
                                        }),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-outline-default ml-1",
                                    attrs: {
                                      disabled: _vm.loadingSend,
                                      title: "Создать заказ",
                                      type: "button",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.makeOrder(client)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-medkit",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e()
                    }),
                  ],
                  2
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          !_vm.loading && !_vm.items.length
            ? _c("div", [_vm._v("\n        Нет активных сегментов\n      ")])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.items, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "segment-item d-flex",
                attrs: { id: "segmentItem" + item.id },
              },
              [
                _c("div", [
                  _c("h6", [
                    _vm._v(_vm._s(item.title) + " "),
                    _c("span", { staticStyle: { "font-weight": "normal" } }, [
                      _vm._v("[ID: " + _vm._s(item.id) + "]"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-items" }, [
                    _c("div", { staticClass: "info-item date-items" }, [
                      item.includeFrom || item.includeTo
                        ? _c("span", { staticClass: "include-label" }, [
                            _c("i", { staticClass: "icon-fa icon-fa-plus" }),
                            _vm._v(
                              "\n                " +
                                _vm._s(item.includeFrom || "...") +
                                " — " +
                                _vm._s(item.includeTo || "...") +
                                "\n              "
                            ),
                          ])
                        : _vm._e(),
                      _c("br"),
                      _vm._v(" "),
                      item.excludeFrom || item.excludeTo
                        ? _c("span", { staticClass: "exclude-label" }, [
                            _c("i", { staticClass: "icon-fa icon-fa-minus" }),
                            _vm._v(
                              "\n                " +
                                _vm._s(item.excludeFrom || "...") +
                                " — " +
                                _vm._s(item.excludeTo || "...") +
                                "\n              "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("b", [_vm._v("Клиентов:")]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "clients-info",
                          style:
                            "opacity:" +
                            (_vm.loadingClients === item.id ? "50" : "100") +
                            "%",
                          on: {
                            click: function ($event) {
                              return _vm.showClients(item)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(item.canSendCount) +
                              " (" +
                              _vm._s(item.clientsCount) +
                              ")"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "progress" }, [
                        _c("div", {
                          staticClass: "progress-bar",
                          style:
                            "width:" +
                            (item.sentSmsCount * 100) / item.clientsCount +
                            "%",
                          attrs: { role: "progressbar" },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("b", [_vm._v("Доступно:")]),
                      _vm._v(" " + _vm._s(item.inStore) + " уп.\n            "),
                    ]),
                    _vm._v(" "),
                    _vm.smsSpoiler.includes(item.id)
                      ? _c("div", { staticClass: "info-item" }, [
                          _c("b", [_vm._v("Отправлено:")]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "clients-info",
                              style:
                                "opacity:" +
                                (_vm.loadingSms === item.id ? "50" : "100") +
                                "%",
                              on: {
                                click: function ($event) {
                                  return _vm.showSms(item)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.sentSmsCount) + " смс")]
                          ),
                        ])
                      : _c("div", { staticClass: "info-item" }, [
                          _c(
                            "span",
                            {
                              staticClass: "clients-info",
                              on: {
                                click: function ($event) {
                                  return _vm.showSmsSpoiler(item.id)
                                },
                              },
                            },
                            [_vm._v("СМС")]
                          ),
                        ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "send-wrap" }, [
                  _vm.smsSpoiler.includes(item.id)
                    ? _c("b", [_vm._v("Отправить")])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex align-items-center" }, [
                    _vm.smsSpoiler.includes(item.id)
                      ? _c(
                          "div",
                          { staticClass: "input-group mt-1 flex-nowrap" },
                          [
                            _c("input", {
                              staticClass: "form-control input-sm",
                              attrs: {
                                id: "segmentSmsCount" + item.id,
                                type: "number",
                              },
                              domProps: { value: item.toSendCount },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group-append" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-outline-success",
                                  attrs: {
                                    disabled: _vm.loadingSend,
                                    type: "button",
                                    title: "Отправить",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.sendSms(item, true)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-fa icon-fa-send",
                                  }),
                                ]
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group ml-2" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-outline-primary mr-1",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.mixinGoToRouter("segmentSMS", {
                                id: item.id,
                              })
                            },
                          },
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-pencil" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-outline-danger",
                          on: {
                            click: function ($event) {
                              return _vm.deleteItem(item)
                            },
                          },
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-trash" })]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm.loadingSend === item.id
                  ? _c("div", {
                      staticClass: "send-progress",
                      style: { width: _vm.loadingSendProgress + "%" },
                    })
                  : _vm._e(),
              ]
            )
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }